import { msg } from '@lingui/core/macro';
import { restrictRoute } from 'components/protected-route';
import General from './general';
import MyAccount from './my-account';
import Users from './users';
import Roles from './roles';
import SystemHealth from './system-health';
import License from './license';
// import OPCConfiguration from './opc-configuration';


export default [
  {
    id: 'general',
    name: 'General Settings',
    trans: msg`General Settings`,
    path: 'general',
    access: ['CanChangeConfiguration'],
    Component: General
  },
  {
    id: 'my-account',
    name: 'My Account',
    trans: msg`My Account`,
    path: 'my-account',
    Component: MyAccount
  },
  restrictRoute({
    id: 'users',
    name: 'User Management',
    trans: msg`User Management`,
    path: 'users',
    access: ['AccountManager'],
    Component: Users
  }),
  restrictRoute({
    id: 'roles',
    name: 'Role Management',
    trans: msg`Role Management`,
    path: 'roles',
    access: ['AccountManager'],
    Component: Roles
  }),
  restrictRoute({
    id: 'system-health',
    name: 'System Health',
    trans: msg`System Health`,
    path: 'system-health',
    access: ['CanChangeConfiguration'],
    Component: SystemHealth
  }),
  restrictRoute({
    id: 'license',
    name: 'License',
    trans: msg`License`,
    path: 'license',
    access: ['CanChangeConfiguration'],
    Component: License
  }),
  // restrictRoute({
  //   id: 'opc-configuration',
  //   name: 'OPC Configuration',
  //   trans: msg`OPC Configuration`,
  //   path: 'opc-configuration',
  //   access: ['CanChangeConfiguration'],
  //   Component: OPCConfiguration
  // })
];
